<template>
    <div class="ml-3 mb-3 reply pl-3 pt-3 pr-3 pb-1">
        <b-form-textarea id="textarea" v-model="text"
placeholder="Enter something..." rows="3" max-rows="6"></b-form-textarea>

    <div class="mt-3 mb-0 sm-text">{{ text }}</div>
    </div>
</template>

<script>
    export default {
        name: 'SupportTicketNewReply',

        methods: {
            action: function () {
                this.$emit('action');
            }
        },

        data() {
            return {
                text: ''
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/variables';

    .reply {
        background: #f4f4f4;
    }

    .sm-text {
        font-size: 12px;
    }
</style>
